import { render, staticRenderFns } from "./PartnerAuthRedirectPage.vue?vue&type=template&id=ea0bfa64"
import script from "./PartnerAuthRedirectPage.vue?vue&type=script&lang=js"
export * from "./PartnerAuthRedirectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports